export function phaseRunningFromState(state, rows, streaming) {
  if (state === 'pending') return true
  if (!streaming) return false
  return rows?.some((row) => row.status === 'running')
}

export function isResearchCategory(categoryOrId) {
  const key = String(categoryOrId ?? '').toLowerCase()
  return key === 'research' || key.includes('search')
}
